<div class="wrap margin-large-top-res">

    <div class="uk-form-stacked">

        <div class="uk-margin uk-display-inline-block research-form-controls search">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <button class="uk-form-icon uk-form-icon-flip pointer" type="submit" style="border: none; background: inherit;"> 
                    <img src="../../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                </button>
                <input class="search-bar" type="text" [(ngModel)]="search" (ngModelChange)="onSearchChange($event)" placeholder="Rechercher">
            </div>
        </div>

        <a class="button bold button-align uk-display-inline-block uk-float-right uk-margin-left uk-margin-bottom" 
        href="#add-society" 
        uk-toggle>
         <span>Nouveau adhérent</span>
         <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="add" class="uk-margin-left">
     </a>

        <button class="button bold button-align uk-display-inline-block uk-float-right" (click)="exportDataAsXLSX()" type="button">
            <span *ngIf="excelLoading === false">
                <span class="vertical-align-middle">Export</span>
                <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user" class="uk-margin-left"/> 
            </span>
            <span *ngIf="excelLoading === true">
                <div uk-spinner class="loading-small-button"></div>
            </span>
        </button>
        
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas d'adhérents.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false" class="uk-margin-top">

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top uk-width-1-1">
            <a href="#" uk-grid *ngFor="let society of societies; let i = index"
            class="uk-width-1-1 item-list alt color-grey remove-grid-ml-pl pointer" [routerLink]="['/user/society/informations', society.Id]">
                <div class="uk-visible@m uk-width-1-12 item-column">
                    <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/Adherent.svg" width="48px" height="48px" alt="adherent"/>
                </div>
                <div class="uk-width-9-12 item-column bold" style="font-size: 15px;">
                    <span>{{ society.Name }}</span>
                </div>
                <div class="uk-width-expand item-column"></div>
                <div class="uk-width-1-12 item-column">
                    <div class="arrow-button">
                        <img src="../../../assets/icons/ArrowRight.svg" width="30px" height="30px" alt="user"/>
                    </div>
                </div>
            </a>
        </div>

        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
            <div class="uk-position-center">
                <button [disabled]="currentPage === 1" class="uk-button button" (click)="prevPage()">Précédent</button>
                <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue" (click)="goPage(i + 1)">{{i + 1}}</div>
                </div>
                <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left" (click)="nextPage()">Suivant</button>
            </div>
        </div>

    </div>

</div>

<app-add-society
    (changed)="updateSocieties()"
></app-add-society>